<template>
  <div class="">
    <div v-if="lsCurrencyRatePlans && lsCurrencyRatePlans.length">
      <CCard
        color="secondary"
        v-for="(currency, index) in lsCurrencyRatePlans"
        :key="index + 'curr'"
      >
        <CCol>
          <CCardHeader>
            <CRow class="no-wrap">
              <CCol col="10">
                <h4>
                  {{ $t("ratePlanAll.ratePlan") }} {{ currency.currency }}
                </h4>
              </CCol>
              <CCol col="2">
                <CButton @click="navToNew(null, currency.currency)">
                  {{ "Create Rate Plan" }}
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>
          <transition-group v-if="currency.ratePlans" name="flip-list" tag="ul">
            <div
              v-for="(ratePlan, index) in currency.ratePlans"
              :key="index + 'ratePlan'"
            >
              <CRow v-if="!showMore ? index < 2 : true">
                <CCol :col="showCancellationPolicy ? '6' : '12'">
                  <div class="card assign pricing-card">
                    <div class="card-head d-flex ai-center">
                      <div class="align-left a-name agency-name">
                        <h3>{{ ratePlan.name }}</h3>
                        <span>{{ ratePlan.description }}</span>
                      </div>

                      <div class="align-left  a-name s-date">
                        <p>{{ $t("ratePlanAll.val") }}</p>
                        <span>
                          {{ ratePlan.validityFrom | formatDate }}
                          {{ $t("ratePlanAll.to") }}
                          {{ ratePlan.validityTo | formatDate }}
                        </span>
                      </div>

                      <div
                        v-if="canEdit"
                        @click="navToNew(ratePlan)"
                        col="2.5"
                        class="edit-icon icon-25px c-pointer"
                        color="info removewrap"
                        v-c-tooltip.hover="{
                          content: $t('ratePlanAll.edit'),
                          active: false,
                        }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="512pt"
                          viewBox="0 0 512 512"
                          width="512pt"
                          style="fill:#3c4b64;"
                        >
                          <path
                            d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                            d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                            d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>

                      <!-- <div
                        v-if="canEdit"
                        col="2.5"
                        size="sm"
                        color="danger"
                        v-c-tooltip.hover="{
                          content: $t('ratePlanAll.delete'),
                          active: false,
                        }"
                        class=" icon-25px c-pointer"
                      >
                        <CIcon
                          style="color: #cd0606;font-size:22px;"
                          name="cil-trash"
                          size="lg"
                        ></CIcon>
                      </div> -->
                    </div>
                    <div class="card-body pb-0px report_table_div-section">
                      <table>
                        <thead>
                          <th>
                            {{ $t("ratePlanAll.minStay") }}
                          </th>
                          <th>
                            {{ $t("ratePlanAll.maxStay") }}
                          </th>
                          <!-- <th>
                            {{ $t("ratePlanAll.curr") }}
                          </th> -->
                          <th>
                            {{ $t("ratePlanAll.advPurchase") }}
                          </th>
                          <th>
                            {{ $t("ratePlanNew.priceDrop") }}
                          </th>
                          <th>
                            {{ $t("ratePlanAll.guestInc") }}
                          </th>
                          <th>
                            {{ $t("ratePlanAll.extraAdult") }}
                          </th>
                          <th>
                            {{ $t("ratePlanAll.extraChildRate") }}
                          </th>
                          <!-- <th>
                            {{ $t("ratePlanAll.roomType") }}
                          </th> -->
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {{
                                $tc("ratePlanNew.Day", ratePlan.minstay, {
                                  n: 1,
                                })
                              }}
                            </td>
                            <td>
                              {{
                                $tc("ratePlanNew.Day", ratePlan.maxstay, {
                                  n: 1,
                                })
                              }}
                            </td>

                            <td>
                              {{
                                $tc(
                                  "ratePlanNew.Day",
                                  ratePlan.advpurchaseDays,
                                  { n: 1 }
                                )
                              }}
                            </td>
                            <td>
                              {{
                                $tc(
                                  "ratePlanNew.Day",
                                  ratePlan.lastminutePricedropDays,
                                  { n: 1 }
                                )
                              }}

                              <span>
                                ({{
                                  parseInt(ratePlan.lastminutePricedropPercent)
                                    ? ratePlan.lastminutePricedropPercent
                                    : "0"
                                }}%)
                              </span>
                            </td>
                            <td>
                              {{ ratePlan.noOfPax }}
                            </td>
                            <td>
                              {{ ratePlan.extraAdultprice }}
                              {{
                                RATE_PLAN_PRICING &&
                                ratePlan.extraAdultpriceType ==
                                  RATE_PLAN_PRICING.PERC
                                  ? " %"
                                  : " "
                              }}
                            </td>
                            <td>
                              {{ ratePlan.extraChildprice }}
                              {{
                                RATE_PLAN_PRICING &&
                                ratePlan.extraChildpriceType ==
                                  RATE_PLAN_PRICING.PERC
                                  ? " %"
                                  : " "
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CCol>

                <CCol
                  class="card assign pricing-card"
                  col="4"
                  v-if="cancellationPolicies && showCancellationPolicy"
                >
                  <strong>Cancellation Policies</strong>
                  <div
                    v-if="
                      Object.keys(cancellationPolicies).includes(ratePlan.id)
                    "
                    class="cancellation-card"
                  >
                    <div
                      v-for="(policy, pindex) in cancellationPolicies"
                      :key="pindex + 'policy'"
                    >
                      <div v-if="ratePlan.id == pindex">
                        <CRow>
                          <CCol col="10">
                            <div
                              class="cancellation-card"
                              v-for="(policyObj, pObjindex) in policy"
                              :key="pObjindex + 'policyObj'"
                            >
                              <div
                                v-if="
                                  !showMoreCancellation ? pObjindex <= 1 : true
                                "
                              >
                                <CRow
                                  v-if="
                                    policyObj.hotelCancelBreakdowns.length != 0
                                  "
                                >
                                  <CCol col="5">
                                    <strong> Valid from </strong
                                    ><span
                                      >{{ policyObj.validfrom | formatDate
                                      }}<strong>{{ " to " }}</strong
                                      >{{
                                        policyObj.validto | formatDate
                                      }}</span
                                    >
                                  </CCol>
                                  <CCol col="5">
                                    <div
                                      v-for="(cancelPolicy,
                                      cindex) in policyObj.hotelCancelBreakdowns"
                                      :key="cindex + 'cancelPolicy'"
                                    >
                                      <!-- {{cancelPolicy.noOfDaysBeforeCheckin+' '}}  -->

                                      {{
                                        "Between" +
                                          " " +
                                          $tc(
                                            "cancellationNew.Day",
                                            cancelPolicy.noOfDaysBeforeCheckinFrom,
                                            {
                                              count: Number(
                                                cancelPolicy.noOfDaysBeforeCheckinFrom
                                              ),
                                            }
                                          ) +
                                          " till " +
                                          $tc(
                                            "cancellationNew.Day",
                                            cancelPolicy.noOfDaysBeforeCheckin,
                                            {
                                              count: Number(
                                                cancelPolicy.noOfDaysBeforeCheckin
                                              ),
                                            }
                                          )
                                      }}

                                      <strong>
                                        {{
                                          cancelPolicy.refundfee == "0.0"
                                            ? "Non-Refundable"
                                            : cancelPolicy.refundfee == "100.0"
                                            ? "Full Refundable"
                                            : parseFloat(
                                                cancelPolicy.refundfee
                                              ) + "% Refundable"
                                        }}</strong
                                      >
                                    </div>
                                  </CCol>
                                  <CCol
                                    v-if="cancelPolicyEditDelete.canEdit"
                                    col="2"
                                    @click="
                                      navToEditCancellationPolicy(policyObj)
                                    "
                                  >
                                    <strong
                                      ><CLink>{{ "Edit" }}</CLink></strong
                                    >
                                  </CCol>
                                </CRow>
                              </div>
                            </div>
                          </CCol>

                          <CCol col="2">
                            <div>
                              <strong
                                ><span
                                  @click.stop="
                                    navToAddCancellationPolicy(ratePlan)
                                  "
                                >
                                  <CLink> +Add </CLink>
                                </span></strong
                              >
                            </div>

                            <div v-if="policy.length > 2">
                              <strong
                                ><span
                                  @click.stop="
                                    showMoreCancellation = !showMoreCancellation
                                  "
                                  >{{
                                    showMoreCancellation
                                      ? "View Less"
                                      : "View More"
                                  }}</span
                                >
                              </strong>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </div>
                    <!-- <div v-if="Object.keys(cancellationPolicies).length==0">
                      <CButton @click="navToEditCancellationPolicy(cancellationPolicies)">
                            Add

                          </CButton>
                    </div> -->
                  </div>
                  <div v-else>
                    <span @click.stop="navToAddCancellationPolicy(ratePlan)">
                      <CLink>Add</CLink>
                    </span>
                  </div>
                </CCol>
                <CCol v-else-if="isLoading">
                  <div v-if="isLoading" class="text-center my-5">
                    <div
                      data-v-211fa86d=""
                      role="status"
                      aria-hidden="false"
                      class="spinner-grow spinner-grow-lg text-primary"
                      aria-label="Loading"
                    ></div>
                  </div>
                </CCol>

                <CCol
                  class="card assign pricing-card"
                  v-if="showCancellationPolicy"
                  col="1"
                >
                  <div @click.stop="assignCloneDetails(ratePlan)">
                     <CLink>
                    <CIcon name="cilClone" size="lg"                           v-c-tooltip.hover="{
                            content: 'Clone',
                            active: false,
                          }"></CIcon>
                           </CLink>
                  </div>

                  <strong @click="navToTariffSetup(ratePlan)">
                    <CLink>
                      <CIcon name="cilMoney" size="lg"></CIcon>
                      Tariff
                      <!-- Setup -->
                    </CLink>
                  </strong>
                </CCol>
              </CRow>
            </div>
          </transition-group>

          <CCard
            class="col-11 text-center px-5"
            v-if="
              !showMore && currency.ratePlans && currency.ratePlans.length > 1
            "
          >
            <CLink @click="navToAllRatePlan()">
              <strong>View All</strong>
            </CLink>
          </CCard>
        </CCol>
      </CCard>
    </div>
    <div v-else-if="isLoading" class="text-center my-5">
      <div class="text-center my-5">
        <div
          data-v-211fa86d=""
          role="status"
          aria-hidden="false"
          class="spinner-grow spinner-grow-lg text-primary"
          aria-label="Loading"
        ></div>
      </div>
    </div>
    <div v-else>
      <span>
        <center>
          {{ $t("ratePlanAll.noPlan") }}
        </center>
      </span>
      <CCol>
        <CButton @click="navToNew()">
          {{ "Create Rate Plan" }}
        </CButton>
      </CCol>
    </div>
    <CCardFooter v-if="showMore">
      <CCardFooter>
        <CRow class="justify-content-end">
          <CButton
            @click="navToPrevious()"
            color="danger"
            class="action-c-btn mr-15px"
            >{{ $t("ratePlanAll.goBack") }}</CButton
          >
        </CRow>
      </CCardFooter>
    </CCardFooter>
    <ValidationObserver v-slot="{handleSubmit}">
      <CForm @submit.prevent="handleSubmit(onCloneFormSubmit)">
        <CModal
          v-if="showCloneModal"
          :show.sync="showCloneModal"
          :closeOnBackdrop="false"
          :centered="true"
          size="lg"
          :title="'sdd'"
        >
          <template #header>
           
          <div>

          
          
            <strong
              v-if="
                cloneDetails &&
                  cloneDetails.newRatePlan &&
                  cloneDetails.newRatePlan.room
              "
            >
              {{ cloneDetails.currentRatePlan.roomname }}
            </strong>
           <div>

          
            <label v-if="cloneDetails && cloneDetails.currentRatePlan">
              {{ cloneDetails.currentRatePlan.ratePlanName }}
            </label>
             </div>
             </div>  
          </template>

          <template #default>
            <CRow>
              <CCol>

                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                  <label>
                    {{$t('ratePlanAll.selRoom')}}
                  </label>
                  <multiselect
                    v-if="GET_HOTEL_ROOMS && GET_HOTEL_ROOMS.length"
                    :allow-empty="false"
                    :options="GET_HOTEL_ROOMS"
                    v-model="cloneDetails.newRatePlan.room"
                    trackBy="roomid"
                    label="roomname"
                     :show-labels="false"
                    :placeholder="$t('ratePlanAll.selRoom')"
                    :custom-label='getHotelRoomId'
                  >
                            <template slot="singleLabel" slot-scope="{ option }"
                          >{{ option.roomname }}</template>
                               <template slot="option" slot-scope="props"
                    ><span> {{ props.option.roomname }}</span>
                    <strong class="right ml-auto">{{
                      props.option.roomid
                    }}</strong>
                  </template>
                  </multiselect>
                  <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </CCol>

              <CCol>
                <cTextInputComponent
                     :rules="'required|noInitialSpace|max:150'"
                  v-model="cloneDetails.newRatePlan.ratePlanName"
                  :label="$t('ratePlanAll.newRp')"
                  :placeholder="$t('ratePlanAll.newRpPl')"
                >
                </cTextInputComponent>
              </CCol>
            </CRow>
            <CRow>
              <CCol>

              
              <label>
                <input type="checkbox" v-model="cloneDetails.includeTariff" />

             {{$t('ratePlanAll.cloneTariff')}}
              </label>
              </CCol>
            </CRow>
          </template>

          <template #footer>
            <!-- <CAlert v-if="alertValue" color="warning" closeButton>
                {{ alertValue }}
              </CAlert> -->

            <div class="main-cta-btn">
              <CButton
                color="danger"
                class="action-c-btn"
                @click="toggleCloneModal()"
              >
                <img src="@imgPath/img/svg/icons/close.svg" />
                {{ $t("ratePlanAll.cancel") }}</CButton
              >
              <!-- <CButton v-if="showBtn"
                  type="submit"
                  v-c-tooltip.hover="isImageSaved==false?
                { content:'Please save the image',active:false }:
                ''"
                  @click.prevent="isImageSaved?handleSubmit(onRoomFormSubmit):null"
                  color="success removewrap"
                  class="action-c-btn"
                > -->
              <CButton
                type="submit"
                color="success removewrap"
                class="action-c-btn"
              >
                <img src="@imgPath/img/svg/icons/correct.svg" />
                {{ $t("ratePlanAll.cloneNow") }}</CButton
              >
            </div>
          </template>
        </CModal>
      </CForm>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { COMPONENT_NAME, ORDER, PATHNAME } from "../../../../util/constants";
import router, { goBack, navigate } from "../../../../router/index";

import { mapGetters, mapActions } from "vuex";
import Logger from "../../../../services/logger";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,showSuccessToast,
  cloneDeep,
  groupBy,
  OrderByList,
  GroupByList,
} from "../../../../util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import apiGetRatePlan from "../../../../services/apiGetRatePlan";
import apiCloneRatePlan from "../../../../services/apiCloneRatePlan";
import apiUpdateHotelGuestAgeSetup from "../../../../services/apiUpdateHotelGuestAgeSetup";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cAlertModal from "../../../../components/form/cAlertModal";
import multiselect from "vue-multiselect";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
import apiGetHotelCancelPolicy from "../../../../services/apiGetHotelCancelPolicy";
export default {
  name: COMPONENT_NAME.C_ROOM_RATE_PLANS,

  components: {
    multiselect,
    cTextInputComponent,
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    hotelRoomObj: {
      type: Object,
      default: null,
    },
    showCancellationPolicy: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      lsCurrencyRatePlans: [],
      canEdit: true,
      viewMore: false,
      cancellationPolicies: null,
      showMoreCancellation: false,
      showCloneModal: false,
      noPolicyRatePlan: [],
      isLoading: true,
      cancelPolicyEditDelete: null,

      cloneDetails: {
        includeTariff: false,
        currentRatePlan: {
          roomId: null,
          ratePlanId: null,
          ratePlanName: null,
        },
        newRatePlan: {
          room: null,
          ratePlanName: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
      RATE_PLAN_PRICING: "GET_RATE_PLAN_PRICING",
    }),
    ...mapGetters("sRatePlan", {
      GET_HOTEL_ROOMS: "GET_HOTEL_ROOMS",
    }),

    ...mapGetters("sHotelInfo", { GET_HOTEL_ROOM_OBJ: "GET_HOTEL_ROOM_OBJ" }),
  },
  methods: {
    ...mapActions("sRatePlan", {
      SET_SEL_RATE_PLAN: "SET_SEL_RATE_PLAN",
      SET_CURRENCY: "SET_CURRENCY",
    }),
    ...mapActions("sTariff", { SET_TARRIF_RATE_PLAN: "SET_SEL_RATE_PLAN" }),
    ...mapActions("sHotelInfo", {
      SET_RATE_PLAN: "SET_RATE_PLAN",
      SET_HOTEL_ROOM_OBJ: "SET_HOTEL_ROOM_OBJ",
      SET_SEL_HOTEL_ROOM_OBJ: "SET_SEL_HOTEL_ROOM_OBJ",
      SET_CANCEL_POLICY: "SET_CANCEL_POLICY",
      SET_CANCEL_POLICY_DELETE: "SET_CANCEL_POLICY_DELETE",
    }),

      getHotelRoomId({roomname,roomid})
    {
       return `${roomname} — [${roomid}]`
    },

    getCloneRequest(pHotelId, pCloneDet) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getCloneRequest");

        let isValidCloneDetails =
          pHotelId &&
          pCloneDet &&
          pCloneDet.currentRatePlan && pCloneDet.currentRatePlan.ratePlanId!=null
          pCloneDet.newRatePlan &&pCloneDet.newRatePlan.room;

        if (isValidCloneDetails) {
          retValue = {
            hotelId: pHotelId,
            oldDetails: {
              roomId: pCloneDet.currentRatePlan.roomId,
              ratePlanId: pCloneDet.currentRatePlan.ratePlanId,
            },
            newDetails: {
              roomId:pCloneDet.newRatePlan.room.roomid,
              ratePlanName:pCloneDet.newRatePlan.ratePlanName,
            },
            includeTariff: pCloneDet.includeTariff,
          };
        } else {
          throw "invalid clone Details";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in getCloneRequest",
          err.toString(),
          "getCloneRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async cloneRateRatePlan() {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("cloneRateRatePlan");

        if (this.hotelObj && this.cloneDetails) {
          let cloneReq = apiCloneRatePlan.buildRequest(
            this.getCloneRequest(this.hotelObj.hotelid, this.cloneDetails)
          );

          if (cloneReq) {
            let cloneRes = await apiCloneRatePlan.getResponse(cloneReq);

            if (VALIDATE_SUCCESS_RES(cloneRes)) {
              retValue = cloneRes.data.data;
            } else {
              let error = getErrorMessage(cloneRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid clone Details";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in cloneRateRatePlan",
          err.toString(),
          "cloneRateRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async onCloneFormSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCloneFormSubmit");

        let  cloneStatus = await this.cloneRateRatePlan();

        if(cloneStatus.id!=null)
        {
          this.toggleCloneModal()
          await this.initData()
          showSuccessToast('cloned successfully')
           
          await  this.initData()
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in onCloneFormSubmit",
          err.toString(),
          "onCloneFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleCloneModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleCloneModal");

        this.showCloneModal = !this.showCloneModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in toggleCloneModal",
          err.toString(),
          "toggleCloneModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    getNewRatePlanName(pOldName) {
        let retValue='';
        try {
          if(BaseConfiguration.isDebug) console.log("getNewRatePlanName");

         retValue = 'Copy of ' +pOldName + ''
        
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_ROOM_RATE_PLANS,
                  "error in getNewRatePlanName",
                  err.toString(),
                  "getNewRatePlanName",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

    assignCloneDetails(pRatePlan) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignCloneDetails");
        if (pRatePlan) {
          this.cloneDetails.newRatePlan = {
            room: this.GET_HOTEL_ROOM_OBJ
              ? this.GET_HOTEL_ROOM_OBJ
              : this.GET_HOTEL_ROOMS[0],
            ratePlanName:  this.getNewRatePlanName(pRatePlan.name)
          };

          this.cloneDetails.currentRatePlan = {
            roomId: pRatePlan.room,
            ratePlanId: pRatePlan.id,
            ratePlanName: pRatePlan.name,
            roomname:this.GET_HOTEL_ROOM_OBJ.roomname
          };

          this.toggleCloneModal();
        } else {
          throw "invalid rate plan selection for clone";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in assignCloneDetails",
          err.toString(),
          "assignCloneDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToPrevious() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToPrevious");
        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.filename,
          "error in navToPrevious",
          err.toString(),
          "navToPrevious",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleViewMore() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleViewMore");

        this.viewMore = !this.viewMore;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in toggleViewMore",
          err.toString(),
          "toggleViewMore",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    navToAllRatePlan() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToAllRatePlan");

        //this.SET_HOTEL_ROOM_OBJ(pHotelRoomObj);
        navigate(PATHNAME.RATE_PLAN_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in navToAllRatePlan",
          err.toString(),
          "navToAllRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    navToTariffSetup(ratePlan) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToTariffSetup");

        if (ratePlan) {
          let selRatePlan = { id: ratePlan.id };
          this.SET_SEL_RATE_PLAN(selRatePlan);
          navigate(PATHNAME.TARIFF_ALL);
        } else {
          throw "invalid room  rate planobj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in navToTariffSetupc",
          err.toString(),
          "navToTariffSetup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getRatePlan(pHotelRoomObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRatePlan");
        if (this.hotelObj && pHotelRoomObj) {
          let ratePlanReq = apiGetRatePlan.buildRequest(
            this.hotelObj.hotelid,
            pHotelRoomObj.roomid
          );

          if (ratePlanReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let ratePlanRes = await apiGetRatePlan.getResponse(ratePlanReq);

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
              //this.showAlert(null);
              retValue = ratePlanRes.data.data;
              this.SET_RATE_PLAN(retValue.list);
            } else {
              let error = getErrorMessage(ratePlanRes);
              //  this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw " invalid hotelObj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in getRatePlan",
          err.toString(),
          "getRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getCancellationPolicy(pHotelRoomObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getCancellationPolicy");
        if (this.hotelObj && pHotelRoomObj) {
          let policyReq = apiGetHotelCancelPolicy.buildRequest(
            this.hotelObj.hotelid,
            pHotelRoomObj.roomid
          );

          if (policyReq) {
            let policyRes = await apiGetHotelCancelPolicy.getResponse(
              policyReq
            );

            if (VALIDATE_SUCCESS_RES(policyRes)) {
              retValue = policyRes.data.data;
            } else {
              let error = getErrorMessage(policyRes);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw " invalid hotelObj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in getCancellationPolicy",
          err.toString(),
          "getCancellationPolicy",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    navToNew(pRatePlan, currency) {
      try {
        if (BaseConfiguration.isDebug) console.log("navToNew");

        if (pRatePlan) {
          let selRatePlan = { id: pRatePlan.id };
          this.SET_SEL_RATE_PLAN(selRatePlan);
          this.SET_CURRENCY(null);
        } else {
          this.SET_SEL_RATE_PLAN(null);
          this.SET_CURRENCY(currency);
        }

        navigate(PATHNAME.RATE_PLAN_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in navToNew",
          err.toString(),
          "navToNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toGroupCancelPolicy(pHotelInfo) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toGroupCancelPolicy");
        retValue = JSON.parse(
          JSON.stringify(groupBy(pHotelInfo.list, "rateplan"))
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in toGroupCancelPolicy",
          err.toString(),
          "toGroupCancelPolicy",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    navToEditCancellationPolicy(cancelPolicy) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("navToEditCancellationPolicy");
        if (cancelPolicy) {
          this.SET_CANCEL_POLICY(cancelPolicy);
          this.SET_SEL_RATE_PLAN(null);
          this.SET_CANCEL_POLICY_DELETE(this.cancelPolicyEditDelete);
        }
        navigate(PATHNAME.CANCELLATION_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in navToEditCancellationPolicy",
          err.toString(),
          "navToEditCancellationPolicy",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    navToAddCancellationPolicy(pRatePlan) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("navToAddCancellationPolicy");
        if (pRatePlan) {
          let selRatePlan = { id: pRatePlan.id };
          this.SET_SEL_RATE_PLAN(selRatePlan);
        } else {
          this.SET_SEL_RATE_PLAN(null);
        }
        this.SET_CANCEL_POLICY(null);
        navigate(PATHNAME.CANCELLATION_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_ROOM_RATE_PLANS,
          "error in navToAddCancellationPolicy",
          err.toString(),
          "navToAddCancellationPolicy",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


   async initData() {
        try {
          if(BaseConfiguration.isDebug) console.log("initData");
          if (this.hotelRoomObj) {
        let ratePlanRes = await this.getRatePlan(this.hotelRoomObj);

        if (ratePlanRes && ratePlanRes.list && ratePlanRes.permission) {
          this.canEdit = ratePlanRes.permission.canEdit;
          let ratePlans = OrderByList(ratePlanRes.list, "name", ORDER.ASC);
          this.lsCurrencyRatePlans = OrderByList(
            GroupByList(ratePlans, "currency", "ratePlans"),
            "currency",
            ORDER.ASC
          );
          this.$emit("ratePlanRes", ratePlanRes);
          if (this.showCancellationPolicy) {
            this.cancellationPolicies = await this.getCancellationPolicy(
              this.hotelRoomObj
            );
            this.cancelPolicyEditDelete = this.cancellationPolicies.permission;
            if (this.cancellationPolicies) {
              this.cancellationPolicies = this.toGroupCancelPolicy(
                this.cancellationPolicies
              );
            }
            //  this.noPolicyRatePlan = Object.keys(this.cancellationPolicies)
          }
        }
      }

      this.isLoading = false;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.filename,
                  "error in initData",
                  err.toString(),
                  "initData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
  await this.initData()
   
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_ROOM_RATE_PLANS,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style>
.cancellation-card {
  padding: 5px 5px;
}
</style>
